import React from 'react';
import { useIntl } from 'react-intl';
import { translate } from '@optimusgps/optimus-intl';
import { Col, Modal, Row, Tag, Typography } from 'antd';
import { formatEmailTypeLabel } from '@/utilities/utilities';
import { EmailEventsLog } from './EmailEventsLog';
import { getStatusTagColor } from './emailLogs.utils';
import { EventHistory } from './EventHistory';

const { Text } = Typography;

export type SelectedEmailLog = {
	providerMessageId: string;
	recipientEmail: string;
	subject: string;
	fromEmail: string;
	emailStatus: string;
	emailType: string;
};

type EventsModalProps = {
	selectedEmailLog: SelectedEmailLog;
	onClose: () => void;
};

type InfoItemProps = {
	label: string;
	value: React.ReactNode;
};

const InfoItem = ({ label, value }: InfoItemProps) => (
	<div className="email-logs__info-item">
		<Text strong className="email-logs__info-item-label">
			{label}
		</Text>
		<Text className="email-logs__info-item-value">{value}</Text>
	</div>
);

export const EventsModal = ({ selectedEmailLog, onClose }: EventsModalProps) => {
	const intl = useIntl();
	const { providerMessageId, recipientEmail, subject, fromEmail, emailStatus, emailType } = selectedEmailLog;

	return (
		<Modal
			title={intl.formatMessage(translate('emailDetails'))}
			open
			onCancel={onClose}
			footer={null}
			destroyOnClose
			width={800}
		>
			<Row gutter={[24, 16]}>
				<Col span={12}>
					<InfoItem
						label={intl.formatMessage(translate('status'))}
						value={
							<Tag className="email-logs__status-tag" color={getStatusTagColor(emailStatus)}>
								{intl.formatMessage(translate(emailStatus?.toLowerCase()))}
							</Tag>
						}
					/>
				</Col>
				<Col span={12}>
					<InfoItem
						label={intl.formatMessage(translate('emailType'))}
						value={formatEmailTypeLabel(emailType)}
					/>
				</Col>
			</Row>
			<Row gutter={[24, 16]}>
				<Col span={12}>
					<InfoItem label={intl.formatMessage(translate('messageId'))} value={providerMessageId} />
				</Col>
				<Col span={12}>
					<InfoItem label={intl.formatMessage(translate('senderEmail'))} value={fromEmail} />
				</Col>
			</Row>
			<Row gutter={[24, 16]}>
				<Col span={12}>
					<InfoItem label={intl.formatMessage(translate('subject'))} value={subject} />
				</Col>
				<Col span={12}>
					<InfoItem label={intl.formatMessage(translate('recipientEmail'))} value={recipientEmail} />
				</Col>
			</Row>
			<EventHistory providerMessageId={providerMessageId} recipientEmail={recipientEmail} />
			<EmailEventsLog providerMessageId={providerMessageId} recipientEmail={recipientEmail} />
		</Modal>
	);
};
